import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { pxToRem } from "@src/utils";

import { StyledSidePaddings } from "../StyledSidePaddings";

export const StyledPage = styled(StyledSidePaddings)<{
  variant?: "settings" | "auth" | "home" | "result";
}>`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: center;

  padding-top: ${pxToRem(40)};
  padding-bottom: ${pxToRem(40)};

  ${({ variant }) => {
    if (variant === "settings") {
      return css`
        max-width: ${pxToRem(1011)};
        gap: ${pxToRem(60)};
      `;
    }
    if (variant === "auth") {
      return css`
        padding-top: 0;
        align-items: center;
      `;
    }
    if (variant === "home") {
      return css`
        max-width: ${pxToRem(1440)};
        gap: ${pxToRem(40)};
        padding-top: ${pxToRem(60)};
        padding-bottom: ${pxToRem(60)};
      `;
    }
    if (variant === "result") {
      return css`
        max-width: 98%;
        gap: ${pxToRem(40)};
        padding-top: ${pxToRem(60)};
        padding-bottom: ${pxToRem(60)};
      `;
    }
    return css`
      max-width: 98%;
      gap: ${pxToRem(40)};
    `;
  }}
`.withComponent("section");
